import React from 'react';
import { SummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';

export const OrderNumber: React.FC = () => {
  const { data } = useSelectCurrentOrder();

  return (
    <SummaryItem label={'Order Number'} tab={'summary'}>
      {data.transaction.file_number}
    </SummaryItem>
  );
};
